export { default } from "./useGenerateClassCode";
